// extracted by mini-css-extract-plugin
export default {"role-assignment":"role-assignment--QeK9I8ghjj","roleAssignment":"role-assignment--QeK9I8ghjj","disabled":"disabled--SZwWOQaNMf","locale":"locale--qsQhiQnXX4"};